import { Callout, Colors, Icon } from '@amelio/ui-library';

import type { ReactNode } from 'react';

interface LockNoticeProps {
    /** Why something can no longer be changed here. */
    children: ReactNode;
    className?: string;
}

/** Says, as information rather than a refusal, why part of a form is locked. */
export const LockNotice = ({ children, className }: LockNoticeProps) => (
    <Callout
        tone={'info'}
        icon={
            <Icon
                name={'security-lock'}
                size={'md'}
                color={Colors.PRIMARY_800}
                ariaHidden
            />
        }
        className={className}
    >
        {children}
    </Callout>
);
